import React from 'react';
import PropTypes from 'prop-types';
import StripeDefs from 'components/stripe-defs';
import * as Mask from 'constants/mask';
import {getMask} from 'utils/attribute-util';
import styles from './index.css';

export default class LegendBarIcon extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    mask: PropTypes.oneOf(Object.values(Mask)),
    style: PropTypes.object,
    width: PropTypes.number,
  };

  static defaultProps = {
    height: 0,
    mask: '',
    style: {},
    width: 0,
  };

  getMask(mask, maskID) {
    return mask === Mask.STRIPE ? getMask(maskID) : null;
  }

  render() {
    const mask = this.getMask(this.props.mask, StripeDefs.getMaskID());
    return (
      <g className={styles.LegendBarIcon}>
        <rect
          height={this.props.height}
          style={{
            ...this.props.style,
            mask,
          }}
          width={this.props.width}
        />
      </g>
    );
  }
}
